import React from 'react'

export const LoadingContext = React.createContext({
    isLoad: false,
    setIsLoad: () => { },
    // isOpenToast: false,
    // setIsOpenToast: () => { },
    // alertMessage: '',
    // setAlertMessage: () => { },
    // colorSnack: '',
    // setColorSnack: () => { },
    // alertFunction: '',
    // setAlertFunction: () => { },
    passValues: '',
    setPassValues: () => { },
    DEFAULTURL: '',
    toastMessages: () => { },
    useComma: true,
    setUseComma: () => { },
    primaryColor: '',
    secondaryColor: '',
    tertiaryColor: '',
})